/** @file Slots of the mesh-edge key table for a mesh: a power of two, at least 1,024 and twice the key count. */

/** Table slots for `triangleIndexCount` keys at most (each triangle index starts one edge): the table stays half empty. */
export function edgeTableSlots(triangleIndexCount: number): number {
  let size = 1024;
  while (size < 2 * triangleIndexCount && size < 2 ** 30) size *= 2;
  return size;
}
